/* TRIMSOUL - global scripts. No frameworks. */
(function () {
  'use strict';

  var TS = window.TRIMSOUL || {};
  window.TRIMSOUL = TS;
  TS.routes = TS.routes || {};
  TS.strings = TS.strings || {};
  TS.money = TS.money || {};

  var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  TS.reducedMotion = function () {
    return !!(motionQuery && motionQuery.matches);
  };

  TS.qs = function (selector, root) {
    return (root || document).querySelector(selector);
  };

  TS.qsa = function (selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  };

  /* ---- money: whole rupees with the ₹ symbol ---- */
  TS.formatMoney = function (cents) {
    var value = Math.round(Number(cents || 0)) / 100;
    var symbol = TS.money.symbol || '\u20B9';

    if (typeof Intl !== 'undefined' && typeof Intl.NumberFormat === 'function') {
      try {
        return new Intl.NumberFormat(TS.money.locale || 'en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(value);
      } catch (error) {
        /* fall through to the plain format */
      }
    }

    return symbol + Math.round(value);
  };

  TS.formatPrices = function (root) {
    TS.qsa('[data-price-value]', root).forEach(function (element) {
      element.textContent = TS.formatMoney(element.getAttribute('data-price-value'));
    });
  };

  /* ---- bag count ---- */
  TS.setBagCount = function (count) {
    var value = Number(count) || 0;
    var hadPrevious = typeof TS.itemCount === 'number';
    var previous = hadPrevious ? TS.itemCount : 0;
    TS.itemCount = value;

    TS.qsa('[data-cart-count]').forEach(function (element) {
      element.textContent = String(value);

      if (hadPrevious && value > previous) {
        element.classList.remove('is-pop');
        void element.offsetWidth;
        element.classList.add('is-pop');
      }

      if (value > 0) {
        element.removeAttribute('hidden');
      } else {
        element.setAttribute('hidden', '');
      }

      var bag = element.parentNode;
      if (bag && bag.setAttribute) {
        bag.setAttribute('aria-label', value > 0 ? 'BAG, ' + value + ' ITEMS' : 'BAG');
      }
    });
  };

  TS.addToBagCount = function (amount) {
    TS.setBagCount((Number(TS.itemCount) || 0) + (Number(amount) || 0));
  };

  TS.refreshBagCount = function () {
    if (!window.fetch || !TS.routes.cart) {
      return;
    }

    window
      .fetch(TS.routes.cart + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        TS.setBagCount(cart.item_count);
      })
      .catch(function () {
        /* keep the server rendered count */
      });
  };

  /* ---- scroll lock ---- */
  TS.lockScroll = function (locked) {
    if (locked) {
      document.body.classList.add('is-locked');
    } else {
      document.body.classList.remove('is-locked');
    }
  };

  /* ---- dialogs ---- */
  TS.openDialog = function (dialog) {
    if (!dialog) {
      return;
    }
    if (typeof dialog.showModal === 'function') {
      try {
        dialog.showModal();
        return;
      } catch (error) {
        /* fall through */
      }
    }
    dialog.setAttribute('open', '');
  };

  TS.closeDialog = function (dialog) {
    if (!dialog) {
      return;
    }
    if (typeof dialog.close === 'function') {
      try {
        dialog.close();
        return;
      } catch (error) {
        /* fall through */
      }
    }
    dialog.removeAttribute('open');
  };

  /* ---- MALE / FEMALE: the active side is remembered in localStorage ---- */
  TS.genderKey = 'trimsoul-gender';

  TS.readGender = function () {
    try {
      return window.localStorage.getItem(TS.genderKey);
    } catch (error) {
      return null;
    }
  };

  TS.writeGender = function (value) {
    try {
      window.localStorage.setItem(TS.genderKey, value);
    } catch (error) {
      /* private mode or storage disabled: the toggle simply is not remembered */
    }
  };

  function initGender() {
    var toggle = TS.qs('[data-gender-toggle]');
    if (!toggle) {
      return;
    }

    var links = TS.qsa('[data-gender]', toggle);
    if (!links.length) {
      return;
    }

    var stored = TS.readGender();
    var fallback = toggle.getAttribute('data-gender-default') || links[0].getAttribute('data-gender');
    var active = stored;

    if (!active) {
      active = fallback;
    }

    /* only accept a stored value that matches one of the real buttons */
    var known = false;
    links.forEach(function (link) {
      if (link.getAttribute('data-gender') === active) {
        known = true;
      }
    });
    if (!known) {
      active = fallback;
    }

    links.forEach(function (link) {
      var on = link.getAttribute('data-gender') === active;
      link.classList.toggle('is-active', on);
      if (on) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
      link.addEventListener('click', function () {
        TS.writeGender(link.getAttribute('data-gender'));
      });
    });
  }

  /* ---- + menu on the home page ---- */
  function initMenu() {
    var menu = document.getElementById('HeaderMenu');
    var opener = TS.qs('.ts-menu-open');
    if (!menu || !opener) {
      return;
    }

    var wrap = menu.parentNode || document;
    var overlay = TS.qs('.sheet-overlay[data-menu-close]', wrap);
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      menu.hidden = false;
      if (overlay) overlay.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      TS.lockScroll(true);

      var firstLink = TS.qs('nav a', menu);
      if (firstLink) {
        firstLink.focus();
      }
    }

    function close() {
      menu.hidden = true;
      if (overlay) overlay.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      TS.lockScroll(false);

      if (lastFocus && lastFocus.focus) {
        lastFocus.focus();
      }
    }

    opener.addEventListener('click', function () {
      var expanded = opener.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        close();
      } else {
        open();
      }
    });

    TS.qsa('[data-menu-close]').forEach(function (element) {
      element.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (menu.hidden) {
        return;
      }
      if (event.key === 'Escape' || event.key === 'Esc') {
        close();
      }
      if (event.key === 'Tab') {
        var focusables = TS.qsa('a[href], button:not([disabled])', menu);
        if (!focusables.length) {
          return;
        }
        var first = focusables[0];
        var last = focusables[focusables.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  function bindDialogClosers() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) {
        return;
      }
      var closer = target.closest('[data-dialog-close]');
      if (!closer) {
        return;
      }
      var dialog = closer.closest('dialog');
      TS.closeDialog(dialog);
    });
  }

  function init() {
    TS.formatPrices(document);
    initGender();
    initMenu();
    bindDialogClosers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify section rendering and apps dispatch this event. */
  document.addEventListener('cart:update', function () {
    TS.refreshBagCount();
  });
})();
